export default __webpack_public_path__ + "static/media/chip-effect.404a3893.mp3";